//------------------------
// is editable race field
//------------------------
export default function isEditableRaceField(field) {

  // define editable (non-calc'ed) fields
  let fields = [
    'combat_inclusion',
    'second_weapon',
    'shield',
    'ranged',
    'magic',
    'special_action',
    'special_reaction',
  ]

  return fields.includes(field)
}
